import { apiClient } from './apiClient';

// -------------------------------------------------------------------------
// Types
// -------------------------------------------------------------------------

export interface VoiceLibraryVoice {
  id: string;
  tenantId: string | null;
  name: string;
  accent: string;
  gender: 'MALE' | 'FEMALE' | 'NEUTRAL';
  provider: string;
  providerVoiceId: string;
  sampleAudioUrl: string | null;
  isActive: boolean;
  isCloned: boolean;
}

export interface VoiceCloneRequest {
  id: string;
  tenantId: string;
  requesterUserId: string;
  voiceName: string;
  status: 'PENDING' | 'TRAINING' | 'READY' | 'FAILED';
  provider: string;
  providerVoiceId: string | null;
  errorDetail: string | null;
  requestedAt: string;
  completedAt: string | null;
}

// -------------------------------------------------------------------------
// Voice catalogue
// -------------------------------------------------------------------------

export async function fetchVoices(activeOnly = true): Promise<VoiceLibraryVoice[]> {
  const { data } = await apiClient.get<VoiceLibraryVoice[]>(
    `/voice-library/voices?activeOnly=${activeOnly}`,
  );
  return data;
}

/** Returns raw MP3 bytes as a Blob for audio playback. */
export async function testSynthesis(voiceId: string, text: string): Promise<Blob> {
  const { data } = await apiClient.post<ArrayBuffer>(
    `/voice-library/voices/${voiceId}/test-synthesis`,
    { text },
    { responseType: 'arraybuffer' },
  );
  return new Blob([data], { type: 'audio/mpeg' });
}

// -------------------------------------------------------------------------
// Voice cloning
// -------------------------------------------------------------------------

export async function fetchCloneRequests(): Promise<VoiceCloneRequest[]> {
  const { data } = await apiClient.get<VoiceCloneRequest[]>('/voice-library/clone-requests');
  return data;
}

export async function submitCloneRequest(
  voiceName: string,
  sampleUrl: string,
): Promise<VoiceCloneRequest> {
  const { data } = await apiClient.post<VoiceCloneRequest>('/voice-library/clone-requests', {
    voiceName,
    sampleUrl,
  });
  return data;
}

export async function pollCloneRequest(requestId: string): Promise<VoiceCloneRequest> {
  const { data } = await apiClient.get<VoiceCloneRequest>(
    `/voice-library/clone-requests/${requestId}`,
  );
  return data;
}
